import { render, staticRenderFns } from "./creditorDetail.vue?vue&type=template&id=3fea86ae&"
import script from "./creditorDetail.vue?vue&type=script&lang=js&"
export * from "./creditorDetail.vue?vue&type=script&lang=js&"
import style0 from "./creditorDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports